// A PÁGINA DE ENDEREÇO QUE NÃO EXISTE — e por que ela aparecia SEM CABEÇALHO.
//
// ── O QUE EU MEDI ───────────────────────────────────────────────────────────────────────────
//
// Em 2026-09-12, varrendo as 25 rotas declaradas em `App.tsx` com o navegador, todas as 25
// tinham a barra de navegação inteira e contraste de no mínimo 6,4:1. Uma única situação
// produzia uma tela sem cabeçalho:
//
//     /rota-que-nao-existe  →  a página inteira era o RODAPÉ, e mais nada.
//
// Nem barra, nem conteúdo, nem aviso. Só o "HQ-LAB · GEOTEC · UNEB" do rodapé flutuando numa
// tela vazia.
//
// ── A CAUSA, E ELA É UMA ASSIMETRIA QUE EU MESMO INTRODUZI ──────────────────────────────────
//
// O rodapé foi IÇADO para fora do `<Routes>` (`RodapeGlobal`, no `App.tsx`), justamente para que
// rota nova ganhasse rodapé por padrão. O cabeçalho NÃO foi: cada página monta o seu `<Nav />`.
//
// A consequência é exatamente o que a varredura mostrou: quando nenhuma rota casa, nenhuma
// página monta, nenhum `<Nav />` existe — e o único elemento içado, o rodapé, fica sozinho na
// tela. O cabeçalho não está "quebrado" nesse caso: ele não chegou a existir.
//
// Por que não içar o cabeçalho também, que seria a correção simétrica: porque `/classico` monta
// um cabeçalho DIFERENTE de propósito (`NavClassico`, fiel ao original), e o editor precisa da
// tela inteira. Um `<Nav />` global teria que ser desligado em duas rotas por exceção — e
// exceção em componente global é o tipo de coisa que alguém esquece ao criar a terceira.
//
// ── POR QUE ISTO IMPORTA MAIS DO QUE UM 404 QUALQUER ────────────────────────────────────────
//
// Dois comentários do `App.tsx` já diziam a mesma frase, escritos em dias diferentes: *"este
// roteador não tem rota curinga, e endereço que some vira página em branco para quem o tem no
// histórico"*. As duas vezes a saída foi redirecionar aquele endereço específico — `/dashboard`
// e `/configuracoes`. Nenhuma das duas resolveu o caso geral, que é qualquer erro de digitação,
// qualquer link velho e qualquer endereço que alguém inventar numa demonstração.
//
// Uma tela em branco não diz à pessoa se ela errou o endereço, se a plataforma caiu ou se a
// conta dela perdeu acesso. Esta diz — e, principalmente, devolve a barra de navegação, que é o
// caminho de volta.

import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Nav from "../../components/nav";
import "./nao-encontrado.scss";

function NaoEncontrado() {
  const local = useLocation();

  useEffect(() => {
    document.title = "Endereço não encontrado · HQ-Lab";
    return () => {
      document.title = "HQ-Lab";
    };
  }, []);

  return (
    <div className="ne-container">
      <Nav />

      <main className="ne-conteudo">
        <p className="ne-codigo">404</p>
        <h1>Este endereço não existe no HQ-Lab</h1>

        {/* O endereço tentado aparece na tela, e não só na barra do navegador: numa aula, quem
            está ajudando a criança olha a TELA dela, não a URL. `wordBreak` porque endereço
            longo não pode empurrar a página para fora da largura. */}
        <p className="ne-tentado">
          Você tentou abrir <code>{local.pathname}</code>
        </p>

        <p className="ne-explica">
          Pode ser um endereço antigo, um link com erro de digitação, ou um quadrinho que foi
          apagado. Nada do que você criou se perde por causa disto — seu acervo continua em
          "Meus quadrinhos".
        </p>

        {/* Três saídas, e são as três coisas que alguém que se perdeu quer: o começo, o que é
            dela, e o que é público. Não é uma lista de tudo — a barra em cima já é essa lista. */}
        <div className="ne-saidas">
          <Link className="ne-botao ne-botao-forte" to="/">
            Ir para o início
          </Link>
          <Link className="ne-botao" to="/meus-quadrinhos">
            Meus quadrinhos
          </Link>
          <Link className="ne-botao" to="/biblioteca">
            Biblioteca
          </Link>
        </div>
      </main>
    </div>
  );
}

export default NaoEncontrado;
